import { AfterViewInit, Component, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, switchMap } from 'rxjs';
import { ClaimModel } from 'src/app/models/calculate-payment-request';
import { ConditionModel } from 'src/app/models/condition.model';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { MultiClaimCalculatorService, PayoutResult } from 'src/app/services/multi-claim-calculator-service';

@Component({
  selector: 'app-apg-multi-claim-calculator',
  templateUrl: './apg-multi-claim-calculator.component.html',
  styleUrls: ['./apg-multi-claim-calculator.component.scss'],
})
export class ApgMultiClaimCalculatorComponent implements OnInit, AfterViewInit {
  claims$ = new BehaviorSubject<ClaimModel[]>([]);
  sumAssured$ = new BehaviorSubject<number>(100000);
  results$: Observable<PayoutResult>;

  constructor(
    private multiClaimCalculatorService: MultiClaimCalculatorService,
    private analyticsService: AnalyticsService
  ) { }

  async ngOnInit() {
    this.results$ = combineLatest([this.claims$, this.sumAssured$]).pipe(
      switchMap(([claims, sumAssured]) => this.multiClaimCalculatorService.calculatePayout(sumAssured, claims))
    );
  }

  ngAfterViewInit(): void {
    //Log GA4 pageview event
    this.analyticsService.logPageView('claim_calculator', { page_title: 'Claim Calculator' });
  }

  sumAssuredChanged(eventData: { sumAssured: number }) {
    this.sumAssured$.next(eventData.sumAssured);
    //this.analyticsService.logEvent('page_event', { page: 'claim_calculator', sumAssured: eventData.sumAssured });    
  }

  addCondition(eventData: { condition: ConditionModel, selected: boolean }) {
    const prev = this.claims$.value
    if (!eventData.selected) {
      let index = prev.findIndex(x => x.conditionCode == eventData.condition.code);
      if (index >= 0) {
        prev.splice(index, 1);
        this.claims$.next(prev);
      }
      //this.analyticsService.logEvent('page_event', { 'page': 'claim_calculator', conditionRemoved: eventData.condition.condition, conditionCodeRemoved: eventData.condition.code });
    }
    else {
      let claim = {
        claimRef: `${prev.length + 1}`,
        conditionCode: eventData.condition.code,
        relatedClaim: eventData.condition.relatedToPrevClaim,
        selected: eventData.condition.checked,
        group: eventData.condition.group
      };

      let index = prev.findIndex(x => x.conditionCode == eventData.condition.code);
      if (index >= 0)
        prev.splice(index, 1);
      prev.push(claim);
      //this.analyticsService.logEvent('page_event', { page: 'claim_calculator', conditionAdded: eventData.condition.condition, conditionCodeAdded: eventData.condition.code });
      this.claims$.next(prev);
    }
  }

  resetGraph() {
    this.claims$.next([]);
  }
}
